export
const name: string = "SvCapSide";

export
const preproc: string = ``;

export
const declaration: string = `
    precision lowp float;

    #ifndef OUTPUT_COLOR
    #define OUTPUT_COLOR gl_FrontFacing ? vec4(0.0,1.0,0.0,1.0) : vec4(1.0,0.0,0.0,1.0)
    #endif//OUTPUT_COLOR
`;

export
const varyings: string = ``;

export
const implementation: string = `
    void main()
    {
        gl_FragColor=OUTPUT_COLOR;
    }
`;
